// Meta Pixel utility — wraps the official fbevents.js snippet.
// Pixel ID: 1729945208277131

const PIXEL_ID = '1729945208277131'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

/**
 * Generates a unique event_id for deduplication between the browser pixel
 * and the server-side Conversions API. Meta uses this to avoid counting
 * the same conversion twice.
 */
export function generateEventId(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`
}

/**
 * Injects the Meta Pixel base script and fires PageView.
 * Safe to call multiple times — only runs once.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  // Standard Meta Pixel base code (https://developers.facebook.com/docs/meta-pixel/get-started)
  /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.body || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq('init', PIXEL_ID)
  // Pass a unique event_id so this PageView can be deduplicated against the
  // server-side (Conversions API) PageView event.
  window.fbq('track', 'PageView', {}, { eventID: generateEventId() })

  // <noscript> fallback pixel for users with JS disabled
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

/**
 * Fires a Meta Pixel event. Use standard events like 'InitiateCheckout',
 * 'Purchase', 'Lead', etc., or pass a custom event name with trackCustom.
 */
export function trackEvent(
  eventName: string,
  params?: Record<string, any>,
  eventId?: string,
): void {
  if (typeof window === 'undefined' || !window.fbq) return
  // Always attach an event_id for deduplication with the Conversions API.
  const id = eventId || generateEventId()
  window.fbq('track', eventName, params, { eventID: id })
}
